import React from "react";

import styles from './members.module.scss';
import KoDP from "packages/dp";
import { KoText } from "packages/typography";

function MobileEmail(props) {
  const { data, size, row } = props;
  return (
    row?.customer?.firstName && <div className={`profileChar ${styles.membersWrapper}`}>
      <div className={`${styles.circle}  ${data ?
        row?.customer?.firstName?.charAt(0).toLowerCase() : 'a'}`}>
        { row?.customer?.['logo'] ?
          <KoDP className={styles.btn} shape={'circle'} logo={ row?.customer?.logo}
            width={ row?.customer?.logo?.[0]?.name ? size ? size : 25 : 25}
            height={ row?.customer?.logo?.[0]?.name ? size ? size : 25 : 25} />
          :
          <KoText className={`${styles.letter}`} text={row?.customer?.firstName?.charAt(0)} />
        }
      </div>
      <div className={styles.memberInfo}>
        <KoText text={`${row?.customer?.firstName} ${row?.customer?.lastName? row?.customer?.lastName : ''}`} className={styles.memberName} />
        {( row?.customer?.email || row?.email) && <KoText text={`${ row?.customer?.email || row?.email}`} className={styles.email} />}
        {( row?.customer?.mobile)&& <KoText text={`${ row?.customer?.mobile || row?.mobile}`} className={styles.email} />}
      </div>
    </div>
  );
}
export default MobileEmail;
